import React, { useContext, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { APIProvider } from "@vis.gl/react-google-maps";
import { CssBaseline } from "@mui/material";
import { ThemeContextProvider } from "./theme";
import { useAuth } from "./contexts/AuthContext";

// components
import ResponsiveAppBar from "./components/navbar";
import Footer from "./components/footer";
import Header from "./components/layouts/Header";
import TipForm from "./components/TipForm"; // Adjust path as needed


// pages
import NotLoggedInHome from "./pages/NotLoggedInHome";
import Newsite from "./pages/Newsite";
import Sites from "./pages/Sites";
import Sitemap from "./pages/Sitesmap";
import SiteUpdate from "./pages/Updatesite";
import Membership from "./pages/Membership";
import Dashboard from "./pages/Divesitedashboard.js";
import Register from "./components/accounts/Register";
import Login from "./components/accounts/Login";
import Profile from "./components/accounts/Profile";
import Logout from "./components/accounts/Logout";
import WithPrivateRoute from "./utils/WithPrivateRoute";
import WithAdminRoute from './utils/WithAdminRoute';
import CreateDiveTrail from "./components/DiveTrails/CreateDiveTrail.js";
import LoggedInHome from "./pages/LoggedInHome.js";
import ClaimDive from "./pages/ClaimDive.js";
import { UnitProvider } from './contexts/UnitContext.js';
import StubEditorPage from "./components/divesitestubs/UpdateDivesiteStub.js";
//import AdminStubEditForm from "./components/accounts/admin/AdminStubEdit.js";
import Admin from './components/accounts/admin/Admin';

function App() {
  const { currentUser } = useAuth();

  return (
    <BrowserRouter>
      <UnitProvider>
      <ThemeContextProvider>
        <CssBaseline />
        <APIProvider apiKey={"AIzaSyBRQwYPeru_FEcLCkVBweQQRjPLBXkzJDs"}>
          <ResponsiveAppBar />
          <Header />
          <Routes>
            <Route
              path="/"
              element={
                currentUser ? (
                  <Navigate to="/loggedinhome" replace />
                ) : (
                  <NotLoggedInHome />
                )
              }
            />
            <Route
              path="/loggedinhome"
              element={
                <WithPrivateRoute>
                  <LoggedInHome />
                </WithPrivateRoute>
              }
            />
            <Route path="/stubs/edit/:stubId" element={<StubEditorPage />} />   

            <Route
              path="/newsite"
              element={
                <WithPrivateRoute>
                  <Newsite />
                </WithPrivateRoute>
              }
            />
            <Route
              path="/sites"
              element={
                <WithPrivateRoute>
                  <Sites />
                </WithPrivateRoute>
              }
            />
            <Route
              path="/sites/update"
              element={
                <WithPrivateRoute>
                  <SiteUpdate />
                </WithPrivateRoute>
              }
            />
                        <Route path="/trails/create" element={<CreateDiveTrail />} />
            <Route
              path="/map"
              element={
                <WithPrivateRoute>
                  <Sitemap />
                </WithPrivateRoute>
              }
            />
            <Route
              path="/map"
              element={
                <WithPrivateRoute>
                  <Sitemap />
                </WithPrivateRoute>
              }
            />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/profile"
              element={
                <WithPrivateRoute>
                  <Profile />
                </WithPrivateRoute>
              }
            />
            <Route
              path="/membership"
              element={
                <WithPrivateRoute>
                  <Membership />
                </WithPrivateRoute>
              }
            />
            <Route
              path="/favoriteDivesites"
              element={
                <WithPrivateRoute>
                  <Dashboard />
                </WithPrivateRoute>
              }
            />
            <Route
              path="/logout"
              element={
                <WithPrivateRoute>
                  <Logout />
                </WithPrivateRoute>
              }
            />
            {/* Removed the WithPrivateRoute wrapper for the claim page */}
            <Route path="/claim/:token" element={<ClaimDive />} />
            {/* Tip routes - both /tip and /tip-success should go to TipForm */}
            <Route
              path="/tip"
              element={
                <WithPrivateRoute>
                  <TipForm />
                </WithPrivateRoute>
              }
            />

            {/* Redirect /tip-success to /tip to maintain backward compatibility */}
            <Route
              path="/tip-success"
              element={
                <WithPrivateRoute>
                <Navigate
                  to={(location) => {
                    // Preserve query parameters when redirecting
                    const search = location.search || "";
                    return `/tip${search}`;
                  }}
                  replace />
                  </WithPrivateRoute>
              }
            />
        {/* Admin route - protected with admin check */}
        <Route 
          path="/admin" 
          element={
            <WithAdminRoute>
              <Admin />
            </WithAdminRoute>
          } 
        />
          </Routes>
          <Footer />
        </APIProvider>
      </ThemeContextProvider>
      </UnitProvider>
    </BrowserRouter>
  );
}

export default App;
